import { CustomButton } from "@/components/custom/custom-button";
import { Box, Divider, Typography, styled } from "@mui/material";
import RoutingConfiguration from "./_components/routing-configuration";
import { useRoutingConfig } from "@/hooks/use-routing-config";
import { RoutingConfigurationSkeleton } from "./_components/routing-configuration-skeleton";
import { useState } from "react";
import RouteConfigDialog from "./_components/route-config-dialog";
import { createUpdateRouteConfig } from "@/services/tech.service";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const RoutingConfig = () => {
  const [editConfigOpen, setEditConfigOpen] = useState(false);
  const { data, isLoading } = useRoutingConfig(true);

  const configData = data?.data;

  return (
    <RootWrapper>
      <Card>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={500} fontSize={18}>
            Routing Configurations
          </Typography>
          <CustomButton
            variantType="outline"
            onClick={() => setEditConfigOpen(true)}
            disabled={isLoading}
            sx={{ minWidth: 100, px: 2 }}
          >
            Edit
          </CustomButton>
        </Box>

        <Divider />

        {isLoading ? (
          <RoutingConfigurationSkeleton />
        ) : (
          <RoutingConfiguration data={configData} />
        )}
      </Card>

      <RouteConfigDialog
        open={editConfigOpen}
        onClose={() => setEditConfigOpen(false)}
        data={configData}
        mutationFn={createUpdateRouteConfig}
      />
    </RootWrapper>
  );
};
